<template>
  <div class="cplan-unit-card__action-move mr-2" v-if="code && periods.length > 0">
    <InputSelect
      ariaLabelText="`Move unit ${code} to another period`"
      id="`move-unit-${code}`"
      defaultText="Move unit to..."
      :options="periods"
      :errors=[]
      v-on:input="change" />

      <transition name="fade">
        <div class="overlay-state overlay-state-loading" v-if="loading">
          <div class="overlay-state__body">
            <i class="overlay-state__icon far fa-spinner-third fa-spin"></i>
            <div class="overlay-state__header">Moving unit...</div>
          </div>
        </div>
      </transition>

  </div>

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import InputSelect from '../common/InputSelect.vue'

export default {
  props: {
    code: { type: String, required: true },
    periods: { type: Array, required: true }
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      unitLockSet: 'plans/unitLockSet',
      unitLockClear: 'plans/unitLockClear',
      generateCoursePlan: 'plans/generateCoursePlan'
    }),
    async change(event, location) {
      const [year, teachingPeriod] = location.split('_')
      this.unitLockSet({ code: this.code, year: year, teachingPeriod: teachingPeriod })
      try {
        this.loading = true;
        await this.generateCoursePlan({ doForceGenerate:true, throwErrorOnNewErrors:true})
      }
      catch(err) {
        this.unitLockClear(this.code)
        //display cannot move message
        setTimeout(() => (this.$emit("displayError", true, err.context)), 0)
        setTimeout(() => (this.$emit("displayError", false)), 5000)
      }

      this.loading = false;
    }
  },
  components: { InputSelect }
}
</script>
